import React, { useContext } from 'react';

import { AppContext } from '../../../context/app';
import useIsMobile from '../../../hooks/useIsMobile';
import { useKioskManager } from '../../../hooks/useKioskManager';
import { useNavigationManager } from '../../../hooks/useNavigationManager';
import AzureDirectionsList from '../azureDirectionsList/azureDirectionsList';
import { KioskDirectionsHeader } from '../kioskDirectionsHeader/KioskDirectionsHeader';
import { LegTwoDirectionsList } from '../LegTwoDirectionsList/LegTwoDirectionsList';
import NavigationDetailsCard from '../navigationDetailsCard/NavigationDetailsCard';
import { ShareBar } from '../shareBar/ShareBar';
import styles from './SectionNavigationSteps.module.scss';

type SectionNavigationStepsProps = {
  onClose: () => void;
};

const SectionNavigationSteps: React.FC<SectionNavigationStepsProps> = ({
  onClose,
}) => {
  const { navDestinationPlace, directions, legToggle } = useContext(AppContext);
  const { legTwoRoute } = useNavigationManager();
  const { kioskMode } = useKioskManager();
  const isMobile = useIsMobile();

  return (
    <>
      <div className={styles.navigationStepsContainer}>
        <ShareBar onClose={onClose} />
        {/*TODO when routing between two on campus locations, do show the starting location. */}
        {kioskMode ? (
          <>
            <KioskDirectionsHeader
              destination={navDestinationPlace?.name || ''}
            />
            {legTwoRoute && <LegTwoDirectionsList collapsed={!legToggle} />}
          </>
        ) : (
          <>
            <NavigationDetailsCard />
            {!isMobile && (
              <>
                {directions && <AzureDirectionsList collapsed={legToggle} />}
                {legTwoRoute && <LegTwoDirectionsList collapsed={!legToggle} />}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default SectionNavigationSteps;
